import React from "react";
import { Form, Row, Col, Button } from "react-bootstrap";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  editModal,
  openModal,
  resetFormState,
  setSelectValidError,
} from "../../../../slices/common/reducer";
import { OemModalLayoutJSON } from "../Json/OemLayoutJson";
import { renderElement } from "../../../../Components/Common/FormRendererV2/Renderer";
import { createOem, updateOem } from "../OemService";
import HubDocuments from "../../../../Components/Common/Documents/HubDocuments";
import { useState } from "react";
import { OemModalFieldsJSON } from "../Json/OemFieldsJson";

const AddNewOem = () => {
  const dispatch = useDispatch();
  const modalShow = useSelector((state) => state.common.modalShow);
  const edit = useSelector((state) => state.common.editShow);
  const formState = useSelector((state) => state.common.formRendererState);
  const oemFieldJson = useSelector((state) => state.oem.oemFieldJson);
  const OemUpdateId = useSelector((state) => state.oem.oemEdit.id);
  const selectedUser = useSelector((state) => state.header.selectedUser);
  const organizationid = selectedUser.organizationid;
  const [isEditing, setIsEditing] = useState({});
  const [filesFetched, setFilesFetched] = useState(false);
  const files = useSelector(
    (state) => state.oem.selectedOem.detailsData.file || {}
  );

  const handleClose = () => {
    dispatch(openModal(false));
    dispatch(editModal(false));
    dispatch(resetFormState());
    dispatch(setSelectValidError(false));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (formState.status) {
      dispatch(setSelectValidError(false));
      const action = edit ? updateOem : createOem;
      action(formState, edit ? OemUpdateId : organizationid, "OEM");
    } else {
      dispatch(setSelectValidError(true));
    }
  };

  const toggleEdit = (fieldKey) => {
    setIsEditing((prev) => ({
      ...prev,
      [fieldKey]: !prev[fieldKey],
    }));
  };
  // const renderField = (child) => {
  //   // If the element type is "column", recursively process its children
  //   if (child.elementtype === "column") {
  //     return (
  //       <div className={child.colsizeclass} key={child.elementid}>
  //         {child.child.map((nestedChild) => renderField(nestedChild))}
  //       </div>
  //     );
  //   }

  //   // If the element type is "documentFile", render the HubDocuments component
  //   if (child.elementtype === "documentFile") {
  //     return (
  //       <HubDocuments
  //         key={child.elementid}
  //         documentLayout={[child]}
  //         documentFields={oemFieldJson}
  //         formState={formState}
  //         files={files}
  //         isEditing={isEditing}
  //         toggleEdit={toggleEdit}
  //         showUploadButtonByDefault={filesFetched}
  //         fetched={filesFetched}
  //       />
  //     );
  //   }

  //   // Default case: Render other element types using renderElement
  //   return renderElement(child, oemFieldJson, formState);
  // };

  return (
    <Modal
      isOpen={modalShow}
      onHide={handleClose}
      centered
      backdrop="static"
      keyboard={false}
      className="border-0"
      modalClassName="modal fade zoomIn"
      toggle={handleClose}
    >
      <Form className="tablelist-form" onSubmit={handleSubmit}>
        <ModalHeader className="p-3 bg-info-subtle" toggle={handleClose}>
          {edit ? "Update OEM" : "New OEM"}
        </ModalHeader>
        <ModalBody className="modal-body">
          <Row className="g-3">
            <Col lg={12}>
              {/* {OemModalLayoutJSON.map((element) => (
                <div key={element.elementid}>
                  {element.child.map((child) => renderField(child))}
                </div>
              ))} */}
              {/* {OemModalLayoutJSON.map((section) => (
                <div key={section.elementid}>
                  {section.child.map((columns) => (
                    <div key={columns.elementid} className="row">
                      {columns.child.map((column) => renderField(column))}
                    </div>
                  ))} */}
              {OemModalLayoutJSON.map((element) => (
                <div key={element.elementid}>
                  {element.child.map((child) =>
                    renderElement(child, OemModalFieldsJSON, formState)
                  )}
                </div>
              ))}
            </Col>
            <Col lg={12}>
              <div className="hstack gap-2 justify-content-end">
                <Button
                  type="submit"
                  className="primary primary_button"
                  id="addNewMember"
                >
                  {edit ? "Update" : "Save"}
                </Button>
              </div>
            </Col>
          </Row>
        </ModalBody>
      </Form>
    </Modal>
  );
};

export default AddNewOem;
